import type { TagSummaryJSONObject } from '@ikegps/core-api';
import { IkeRestObject } from './base';

export class IkeObjectTagSummary extends IkeRestObject<TagSummaryJSONObject> {
	className = 'TagSummary' as const;
	actionName = 'tag.summary';
	object?: TagSummaryJSONObject;
}
